App.controller('chromeExtensionModalCtrl', ($scope, ChromeExtension, CHROME_EXTENSION_PMS) => {
  const CE_PMS = Object.values(CHROME_EXTENSION_PMS).find(pms => pms.ids === ChromeExtension.retrieveChromeExtensionIds())

  $scope.content = CE_PMS.content
  $scope.chromeExtensionURL = CE_PMS.url
})
